// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"6251fd7a","180":"21ec4c9d"}[chunkId] + ".chunk.css";
};